import { ActionType } from '../constants/ActionType';
import { Action } from 'redux';
import { SignOutAction } from './Auth';
import { FolderTree } from '@quick/client';

export const setFolderTreeRoot = (folderTreeRoot: FolderTree): SetFolderTreeRootAction => {
  return {
    type: ActionType.SET_FOLDER_TREE_ROOT,
    folderTreeRoot,
  };
};

export interface SetFolderTreeRootAction extends Action<ActionType.SET_FOLDER_TREE_ROOT> {
  type: ActionType.SET_FOLDER_TREE_ROOT;
  folderTreeRoot: FolderTree;
}

export const setFolderTreeActivePath = (path: string): SetFolderTreeActivePath => {
  return {
    type: ActionType.SET_FOLDER_TREE_ACTIVE_PATH,
    path,
  };
};

export interface SetFolderTreeActivePath extends Action<ActionType.SET_FOLDER_TREE_ACTIVE_PATH> {
  type: ActionType.SET_FOLDER_TREE_ACTIVE_PATH;
  path: string;
}

export type DocumentAction = SetFolderTreeRootAction | SetFolderTreeActivePath | SignOutAction;
